export default __webpack_public_path__ + "static/media/PT.8d8cc6b9.pdf";